import { render } from "./confirmation.view.vue?vue&type=template&id=18cf25ee&scoped=true&ts=true"
import script from "./confirmation.view.vue?vue&type=script&lang=ts"
export * from "./confirmation.view.vue?vue&type=script&lang=ts"

import "./confirmation.view.vue?vue&type=style&index=0&id=18cf25ee&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cf25ee"]])

export default __exports__